import React from 'react';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyCTA } from './components/StickyCTA';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-mint" data-id="element-0" data-mp="3ii4qhxkeukmg">
      <MetaPixel data-id="element-1" data-mp="3mjq2lgp4euvl" />
      <main data-id="element-2" data-mp="3mj6hxs835sdv">
        <HeroSection data-id="element-3" data-mp="3rc9hqi3ghy2i" />
        <StatsBar data-id="element-4" data-mp="3rbzmaezn6ypf" />
        <TransformationSection data-id="element-5" data-mp="3rdkie91luppe" />
        <PainPointsSection data-id="element-6" data-mp="3recctgjguhe3" />
        <KitContentsSection data-id="element-7" data-mp="5os92t1uy7l" />
        <InstantAccessSection data-id="element-8" data-mp="4wyzymxdckh" />
        <BonusesSection data-id="element-9" data-mp="82ld64660ci" />
        <PricingSection data-id="element-10" data-mp="2zl3cxocsjc6w" />
        <GuaranteeSection data-id="element-11" data-mp="2zlv7qwykd5w4" />
        <TestimonialsSection data-id="element-12" data-mp="2zmo6bandcp36" />
        <AboutSection data-id="element-13" data-mp="2zng2amkvootz" />
        <FAQSection data-id="element-14" data-mp="33m5b01uz1i7a" />
        <FinalCTASection data-id="element-15" data-mp="33nq4rp9gox43" />
      </main>
      <Footer data-id="element-16" data-mp="33orjq4tlm3r3" />
      <SocialProofPopup data-id="element-17" data-mp="38lrp0dimj2h5" />
      <StickyCTA data-id="element-18" data-mp="38l8eviz7tido" />
    </div>;
}